import React, { Component } from 'react';
import { connect } from 'react-redux'
import {closePopup} from "../../actions/popup";
import autobind from 'autobind-decorator'
import CommentBlockPopup from '../../components/comments/comment/CommentBlockPopup'
import CommentReplyPopup from '../../components/comments/comment/CommentReplyPopup'
import EditModulePopup from "./EditModulePopup";
import WindowEventHelper from "../../lib/WindowEventHelper";

@connect(state => ({
    isPopupOpened: (typeof state.popup !== 'undefined' && state.popup.isEditSidebarModuleOpened)
}), dispatch => ({
    handlePopupClose: () => {
        dispatch(closePopup())
    },
}))
class SidebarPopupLayer extends Component {
    componentWillUnmount() {
        document.body.className = "";
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isPopupOpened) {
			WindowEventHelper.add("keydown", this.handleKeyDown)

            document.body.className = "scroll_hide";
        }
        else {
			WindowEventHelper.remove("keydown", this.handleKeyDown)

            document.body.className = "";
        }
    }


    @autobind
    handleKeyDown(e) {
        const keyCode = e.keyCode;
        const tagName = e.target.tagName;
        if (keyCode == 27) {
            this.props.handlePopupClose();
        }
    }

    render() {
        const divStyle = {position: 'fixed', display: this.props.isPopupOpened?'block':'none'};
        return (
            <div className="container_layer" style={divStyle}>
                <EditModulePopup/>
            </div>
        );
    }
}

export default SidebarPopupLayer
